module.exports = __webpack_public_path__ + "static/media/responsive-ov.9fa0bc3f.png";